import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendAuthorCompleteTrace,
  BackendQueryAuthorCompleteTraceArgs,
} from 'src/types/backend';

const QUERY = gql`
  query AuthorCompleteTrace($id: ID!) {
    authorCompleteTrace(id: $id) {
      id
      acMachineName
      spans {
        id
        name
        data
        response
      }
    }
  }
`;

type Variables = BackendQueryAuthorCompleteTraceArgs;
type Result = BackendAuthorCompleteTrace;

export const queryAuthorCompleteTrace = async (
  variables: Variables
): Promise<Result | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
